<template>
    <div>
        <h1 style="font-size: 24px; color: black;">聊天室列表</h1>
        <div style="margin-bottom: 10px;">
        <el-tabs type="border-card" v-model="activeName"  @tab-click="handleClick">
            <el-tab-pane label="聊天室" name="first">
                <el-col >
                    <el-card shadow="hover">
                        <el-button  type="primary" @click="showAddChatRoomFormDialog('添加聊天室')">添加聊天室</el-button>
                    </el-card>
                </el-col>
                <el-col>
                    <el-table border
                              row-key="id"
                              :data="chatRoomList"
                              :fit="true">
                        <el-table-column label="ID" prop="id" align="center"></el-table-column>
                        <el-table-column label="图标" align="center">
                            <template slot-scope="scope">
                                <template>
                                    <img :src="VUE_APP_CDN_URL+scope.row.icon" width="60px" height="60px" />
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="聊天室名称" prop="name" align="center"></el-table-column>
                        <el-table-column label="聊天室类型" prop="typeEnum.name" align="center"></el-table-column>
                        <el-table-column label="聊天室标签"  align="center" show-overflow-tooltip>
                            <template slot-scope="scope" >
                                 {{scope.row.tagNames.length===0? " ":scope.row.tagNames.join(" , ")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="简介" prop="detail" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column label="机器人"  align="center" show-overflow-tooltip>
                             <template slot-scope="scope" >
                                 {{scope.row.robotNames.length===0? " ":scope.row.robotNames.join(" , ")}}
                             </template>
                        </el-table-column>
                        <el-table-column label="聊天室规则"  align="center" >
                                <template slot-scope="scope">
                                    <el-button type="text" @click.native.stop="checkRule(scope.row)" >查看</el-button>
                                </template>
                        </el-table-column>
                        <el-table-column label="排序" prop="ranking" align="center"></el-table-column>
                        <el-table-column label="全局禁言"  align="center" width="150px">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.shutUp"
                                           :active-value="true"
                                           :inactive-value="false"
                                           active-text="开启"
                                           inactive-text="关闭"
                                           @change="update(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" align="center">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.createDt,"YYYY-MM-DD HH:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="更新时间"  align="center">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.updateDt,"YYYY-MM-DD HH:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作"  align="center">
                            <template slot-scope="scope">
                                <el-button  type="success"  plain @click="showAddChatRoomFormDialog('编辑聊天室',scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-tab-pane>
            <el-tab-pane label="标签" name="second">
                <el-col >
                    <el-card shadow="hover">
                        <el-button  type="primary" @click="showAddTagFormDialog('添加标签')">添加标签</el-button>
                    </el-card>
                </el-col>
                <el-col>
                    <el-table border
                              :data="tagList"
                            :fit="true">
                        <el-table-column label="ID" prop="id" align="center"></el-table-column>
                        <el-table-column label="图标" align="center">
                            <template slot-scope="scope">
                                <template>
                                    <img :src="VUE_APP_CDN_URL+scope.row.icon" width="60px" height="60px" />
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="标签名称" prop="name" align="center"></el-table-column>
                        <el-table-column label="创建时间" align="center">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.createDt,"YYYY-MM-DD HH:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="更新时间"  align="center">
                            <template slot-scope="scope">
                                {{ formatDate(scope.row.updateDt,"YYYY-MM-DD HH:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作"  align="center">
                            <template slot-scope="scope">
                            <el-button  type="success"  plain @click="showAddTagFormDialog('编辑标签',scope.row)">编辑</el-button>
                            <el-button  type="danger"  plain @click="deleteTag(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-tab-pane>
        </el-tabs>
        </div>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogTagVisible" width="600px">
            <el-form :model="addTagForm">
                <el-form-item label="标签名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addTagForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="标签icon :" :label-width="labelWidth">
                    <el-upload :headers="headers"
                               class="avatar-uploader"
                               :action="uploadURL"
                               :show-file-list="false"
                               :on-success="handleCISuccess"
                               :before-upload="function (file) { return beforeAvatarUpload(file)}"
                               @click="uploadIcon">
                        <img v-if="addTagForm.icon" :src="VUE_APP_CDN_URL+addTagForm.icon" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmTagForm" >提 交</el-button>
                    <el-button type="info" @click="dialogTagVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="规则" center :visible.sync="dialogRuleVisible" width="50%" :data="rule" >
            <el-row type="info" v-for="(item, index) in rule " :key="index">{{item}}</el-row>
        </el-dialog>
        <el-dialog :title="dialogChatRoomTitle" center :visible.sync="dialogChatRoomVisible" width="900px">
            <el-form :model="addChatRoomForm">
                <el-form-item label="聊天室名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addChatRoomForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="聊天室icon :" :label-width="labelWidth">
                    <el-upload :headers="headers"
                               class="avatar-uploader"
                               :action="uploadURL"
                               :show-file-list="false"
                               :on-success="handleCRISuccess"
                               :before-upload="function (file) { return beforeAvatarUpload(file)}"
                               @click="uploadIcon">
                        <img v-if="addChatRoomForm.icon" :src="VUE_APP_CDN_URL+addChatRoomForm.icon" class="avatar">
                        <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="类型选择:" :label-width="labelWidth">
                    <el-select  v-model="addChatRoomForm.roomType">
                        <el-option
                                v-for="item in typeList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签选择:" :label-width="labelWidth">
                    <el-select multiple v-model="addChatRoomForm.tagIds">
                        <el-option
                                v-for="item in tagList"
                                :label="item.name"
                                :value="item.id"
                                :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="机器人:" :label-width="labelWidth">
                    <el-select multiple v-model="addChatRoomForm.robotIds">
                        <el-option
                                v-for="robot in robotList"
                                :label="robot.name"
                                :value="robot.id"
                                :key="robot.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="一句话简介:" :label-width="labelWidth">
                    <el-input
                            type="textarea"
                            maxlength="50"
                            show-word-limit
                            autosize
                            placeholder="请输入内容"
                            v-model="addChatRoomForm.detail">
                    </el-input>
                </el-form-item>
                <el-form-item label="聊天室规则:" :label-width="labelWidth">
                    <el-input
                            type="textarea"
                            maxlength="1000"
                            show-word-limit
                            :rows="5"
                            placeholder="请输入内容"
                            v-model="addChatRoomForm.rule">
                    </el-input>
                </el-form-item>

                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmChatRoomForm(dialogChatRoomTitle)" >提 交</el-button>
                    <el-button type="info" @click="dialogChatRoomVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        chatRoomTagList,
        chatRoomList,
        saveChatRoomTag,
        gameUpload,
        shutUp,
        allEnableRobotList,
        saveChatRoom,
        updateChatRoom,
        batchUpdateChatRoomRanking,
        listChatRoomType,
        deleteChatRoomTag
    }
    from "@/http/api";
    import Sortable from 'sortablejs';
    import utils from '@/utils'
    export default {
        name: "ChatRoomManage",
        inject: ['reload'],
        data(){
            return{
                labelWidth: '110px',
                activeName:'first',
                uploadURL:'',
                dialogTagVisible: false,
                dialogChatRoomVisible: false,
                dialogRuleVisible:false,
                headers:{},
                tagList:[],
                robotList:[],
                typeList:[],
                rule:[],
                chatRoomList:[],
                addTagForm:{},
                addChatRoomForm:{},
                dialogTitle: '',
                dialogChatRoomTitle:'',
                VUE_APP_BASE_URL:'',
                VUE_APP_CDN_URL:'',
                obj:{},
            }
        },
        methods:{
            rowDrop() {
                const tbody = document.querySelector('.el-table__body-wrapper tbody')
                const _this = this;
                Sortable.create(tbody, {
                    onEnd({ newIndex, oldIndex }) {
                       const currRow = _this.chatRoomList.splice(oldIndex, 1)[0]
                        _this.chatRoomList.splice(newIndex, 0, currRow)
                        batchUpdateChatRoomRanking(_this.chatRoomList).then(resp =>{
                            if (resp.data.status===0){
                                _this.reload();
                            }
                        })
                    }
                })
            },
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleClick(tab) {
                this.activeName = tab.name;
                if (tab.name === 'second'){
                    this.chatRoomTags();
                }
            },
            checkRule(_row){
                this.dialogRuleVisible=true;
                this.rule= _row.rule.split("\n").length===0?['暂无内容']: _row.rule.split("\n")
            },
            confirmTagForm(){
                let _message = '';
                if(this.addTagForm.name===''){
                    _message = '请输入标签名称'
                }else if (this.addTagForm.icon===''){
                    _message = '请上传标签图片'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveChatRoomTag(this.addTagForm).then(resp=>{
                    if(resp.data.status===0){
                        this. chatRoomTags();
                        this.dialogTagVisible=false;
                    }
                });
            },
            handleCISuccess(response){
                this.addTagForm.icon=response.info;
            },
            handleCRISuccess(response){
                this.addChatRoomForm.icon=response.info;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'|| file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            uploadIcon(){
                gameUpload().then().catch(function () {
                })
            },
            showAddTagFormDialog(_title, _data) {
                this.dialogTagVisible = true;
                this.dialogTitle = _title;
                this.addTagForm={
                    id: 0,
                    name: '',
                    icon: ''
                };
                if (_data) {
                    this.addTagForm = {
                        id: _data.id,
                        name: _data.name,
                        icon: _data.icon,
                    }
                }
            },
            showAddChatRoomFormDialog(_title, _data){
                this.dialogChatRoomVisible = true;
                this.dialogChatRoomTitle = _title;
                this.chatRoomTags();
                this.chatRoomRobots();
                this.chatRoomTypes();
                this.addChatRoomForm={
                    id: 0,
                    name: '',
                    rule:'',
                    detail:'',
                    ranking:0,
                    shutUp:false,
                    icon: '',
                    robotIds:[],
                    roomType:0,
                    tagIds:[]
                };
                if (_data) {
                    this.addChatRoomForm = {
                        id: _data.id,
                        name: _data.name,
                        rule:_data.rule,
                        detail:_data.detail,
                        ranking:_data.ranking,
                        shutUp:_data.shutUp,
                        icon: _data.icon,
                        roomType:_data.typeEnum.id,
                        robotIds:_data.robotIds,
                        tagIds:_data.tagIds
                    }
                }
            },
            update(row){
                shutUp(row.id,row.shutUp).then().catch(function () {
                })
             },
            chatRoomTags(){
                chatRoomTagList().then(resp =>{
                    this.tagList = resp.data.info;
                })
            },
            chatRoomTypes(){
                listChatRoomType().then(resp =>{
                    this.typeList = resp.data.info;
                })
            },

            chatRoomRobots(){
                allEnableRobotList().then(resp =>{
                    this.robotList = resp.data.info;
                })
            },
            confirmChatRoomForm(param){
                if(param==='添加聊天室'){
                  saveChatRoom(this.addChatRoomForm).then(resp=>{
                      if(resp.data.status===0){
                          this.chatRooms();
                          this.dialogChatRoomVisible=false;
                      }
                  });
                }else{
                  updateChatRoom(this.addChatRoomForm).then(resp=>{
                      if(resp.data.status===0){
                          this.chatRooms();
                          this.dialogChatRoomVisible=false;
                      }
                  });
                }
            },
            chatRooms(){
                chatRoomList().then(resp =>{
                    this.chatRoomList = resp.data.info;
                })
            },
            deleteTag(row){
                this.$confirm('确认是否删除?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteChatRoomTag(row.id).then(resp=>{
                        if (resp.data.status==0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                            this.reload();
                        }else{
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    });
                })
            }
        },
        created() {
            this.headers ={Authorization : this.$store.state.user.token}
            this.chatRooms();
        },
        mounted() {
            document.body.ondrop = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
            this.rowDrop();
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
            this.uploadURL=process.env.VUE_APP_BASE_URL+"game/upload"
        }
    }
</script>

<style scoped>

</style>
